/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:23 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: index.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/app/mixin/index.js
 */

import ErrorsMixin from './errors.mixin'

export default (Vue) => {
    Vue.mixin(ErrorsMixin)
}
